let change_token = function (msg) {
  var _token = {
    token: ""
  };
  _token.token = msg /*需要动态传入的数据*/
  var _setdata_msg = JSON.stringify(_token);
  window.localStorage.setItem("dbclass-spa", _setdata_msg);
}


// 获取SPA里的TOKEN
let get_spa_token = function(){

 var tokenStr = window.localStorage.getItem("dbclass-spa");
 var accessToken = null;
 if (tokenStr) {
      var json = JSON.parse(tokenStr);
      if (json.token) {
        accessToken = json.token.access_token;
      }
  }

  return accessToken;

}

// 设置,学校入驻的token
let set_school_join_token = function(token){
    var json = {};
    json.tokens = "Bearer " + token;
    json.nomal = token;
    localStorage.setItem("new_db_token", JSON.stringify(json));
}

// 获取，学校入驻token
let get_school_join_token = function(token){
    var tokenStr =  localStorage.getItem("new_db_token");
    var accessToken = null;

    if (tokenStr) {
        var json = JSON.parse(tokenStr);
        if (json.tokens) {
          accessToken = json.nomal;
        } 
    }

    return accessToken;
}

// 尝试获取Token，先获取spa的，spa没有获取new_token
let try_get_token = function(){
    // 获取SPAtoken
    var accessToken = get_spa_token();
    if(accessToken){
        // 设置学校入驻token，用于购买计划
        set_school_join_token(accessToken);
    } else {
        // 如果不存在，则获取学校入驻token
        accessToken = get_school_join_token();
        // 如果存在，设置spa的token
        if(accessToken){
          change_token({
            access_token : accessToken
          });
        }
    }

    return accessToken;
}

export {
  change_token,
  get_spa_token,
  set_school_join_token,
  get_school_join_token,
  try_get_token
};


// WEBPACK FOOTER //
// ./src/apis/token.js